export default __webpack_public_path__ + "static/media/welcomeImg.948e8f91.png";